module.exports = __webpack_public_path__ + "36a95dd868afc85c163df9b7f736c733.png";